/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData model module.
 * @module model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData} The populated <code>PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('totalSpendingCount')) {
                obj['totalSpendingCount'] = ApiClient.convertToType(data['totalSpendingCount'], 'Number');
            }
            if (data.hasOwnProperty('totalHolderCount')) {
                obj['totalHolderCount'] = ApiClient.convertToType(data['totalHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('totalHolderBoxCount')) {
                obj['totalHolderBoxCount'] = ApiClient.convertToType(data['totalHolderBoxCount'], 'Number');
            }
            if (data.hasOwnProperty('walletToSpendingCount')) {
                obj['walletToSpendingCount'] = ApiClient.convertToType(data['walletToSpendingCount'], 'Number');
            }
            if (data.hasOwnProperty('spendingToWalletCount')) {
                obj['spendingToWalletCount'] = ApiClient.convertToType(data['spendingToWalletCount'], 'Number');
            }
            if (data.hasOwnProperty('regularCount')) {
                obj['regularCount'] = ApiClient.convertToType(data['regularCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['targetDate'] = undefined;

/**
 * @member {Number} totalSpendingCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['totalSpendingCount'] = undefined;

/**
 * @member {Number} totalHolderCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['totalHolderCount'] = undefined;

/**
 * @member {Number} totalHolderBoxCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['totalHolderBoxCount'] = undefined;

/**
 * @member {Number} walletToSpendingCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['walletToSpendingCount'] = undefined;

/**
 * @member {Number} spendingToWalletCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['spendingToWalletCount'] = undefined;

/**
 * @member {Number} regularCount
 */
PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData.prototype['regularCount'] = undefined;






export default PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData;

